import React from 'react';

const ManagerDetailsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/organizationalsetup/managerdetails',
			component:React.lazy(() => import('./ManagerDetails')) 
        }
	]
};

export default ManagerDetailsConfig;